import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import Header from './components/Header'
import Footer from "./components/Footer";
import Loading from "./components/Loading";

const Home = () => {
    const [selectedTicketTypeId, setSelectedTicketTypeId] = useState("");
    const [ticketTypeIdSommerfest1, setTicketTypeIdSommerfest1] = useState(0);
    const [ticketTypeIdSommerfest2, setTicketTypeIdSommerfest2] = useState(0);
    const [loading, setLoading] = useState(false);
    const [resources, setResources] = useState({});
    const [orderId, setOrderId] = useState("");
    const [availabilitySommerfest1, setAvailabilitySommerfest1] = useState(null);
    const [availabilitySommerfest2, setAvailabilitySommerfest2] = useState(null);
    const [token, setToken] = useState(sessionStorage.getItem("token"));

    const navigate = useNavigate();
    const baseUrl = process.env.REACT_APP_BASEURL_API;

    useEffect(() => {
        loadToken();
    }, []);

    const loadToken = () => {
        axios.get("form/token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
            setToken(res.data);
            sessionStorage.setItem("token", res.data);
            requestFormSettings();
        });
    };

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            setTicketTypeIdSommerfest1(res.data.sommerfest1TicketTypeId);
            setTicketTypeIdSommerfest2(res.data.sommerfest2TicketTypeId);
            startOrder(res.data.posId, res.data.sommerfest1TicketTypeId, res.data.sommerfest2TicketTypeId);
        });
    };

    const startOrder = (posId, ticketTypeId1, ticketTypeId2) => {
        let order = {
            affiliateShopId: null,
            currency: "CHF",
            tenantId: 1,
            pointOfSaleId: posId,
            abbreviation: "",
            paymentType: 1,
            deliveryType: 1,
        };

        axios
            .post(`${baseUrl}/ShopBasket/Order`, order)
            .then((res) => {
                sessionStorage.setItem("orderId", res.data.id);
                setOrderId(res.data.id);
                // Check availability after order is created
                checkAvailability(res.data.id, ticketTypeId1, ticketTypeId2);
            })
            .catch((error) => console.error(error.response.data));
    };

    const checkAvailability = async (orderId, ticketTypeId1, ticketTypeId2) => {
        try {
            // Check availability for Sommerfest 1
            const availability1 = await requestTicketTypeAvailability(ticketTypeId1, orderId);
            setAvailabilitySommerfest1(availability1);

            // Check availability for Sommerfest 2
            const availability2 = await requestTicketTypeAvailability(ticketTypeId2, orderId);
            setAvailabilitySommerfest2(availability2);
        } catch (error) {
            console.error("Error checking availability:", error);
        }
    };

    const requestTicketTypeAvailability = async (ticketTypeId, orderId) => {
        if (!ticketTypeId || !orderId) return null;
        
        try {
            const url = `${baseUrl}/TicketType/${ticketTypeId}/Availability?orderId=${orderId}`;
            const response = await axios.get(url);
            return response.data;
        } catch (error) {
            console.error(`Error fetching availability for ticket type ${ticketTypeId}:`, error);
            return null;
        }
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/de`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    useEffect(() => {
        requestResources();
    }, []);

    const onEventSelect = (e) => {
        setSelectedTicketTypeId(e.target.value);
    };

    const onSubmit = () => {
        if (!selectedTicketTypeId) {
            alert("Bitte w�hlen Sie eine Veranstaltung aus.");
            return;
        }

        // Navigate to shipping page with selected ticket type ID
        navigate(`/de/shipping/${selectedTicketTypeId}`);
    };

    // Helper function to check if a ticket type is sold out
    const isSoldOut = (availability) => {
        return availability && availability.status !== 0;
    };

    return (
        <div>
            <Header resources={resources} />
            {loading ? (
                <Loading
                    alignment="center"
                    color="#d3d3d3"
                    bgColor="#fff"
                    top="50%"
                />
            ) : (
                <>
                    <div className="container page-container">

                        <div className="mt-4 page-container-smaller">

                            <div className="mt-4 mb-2">
                                <p dangerouslySetInnerHTML={{ __html: resources?.HomeTitleDescription }}></p>
                            </div>

                            <div className="mt-2 mb-2">
                                <p dangerouslySetInnerHTML={{ __html: resources?.HomeLocation }}></p>
                            </div>

                            <div className="mb-4">
                                <p className="fs-5 fw-bold">{resources?.HomeEventSelectionTitle}</p>
                            </div>

                            <div className="mb-3">
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="eventSelection"
                                        id="sommerfest1"
                                        value={ticketTypeIdSommerfest1}
                                        checked={selectedTicketTypeId == ticketTypeIdSommerfest1}
                                        onChange={onEventSelect}
                                        disabled={isSoldOut(availabilitySommerfest1)}
                                    />
                                    <label 
                                        className="form-check-label" 
                                        htmlFor="sommerfest1"
                                        style={{ 
                                            opacity: isSoldOut(availabilitySommerfest1) ? 0.5 : 1,
                                            cursor: isSoldOut(availabilitySommerfest1) ? 'not-allowed' : 'pointer'
                                        }}
                                    >
                                        {resources?.HomeSommerfest1Label}
                                        {isSoldOut(availabilitySommerfest1) && (
                                            <span className="text-danger ms-2">(Ausverkauft)</span>
                                        )}
                                    </label>
                                </div>
                            </div>

                            <div className="mb-4">
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="eventSelection"
                                        id="sommerfest2"
                                        value={ticketTypeIdSommerfest2}
                                        checked={selectedTicketTypeId == ticketTypeIdSommerfest2}
                                        onChange={onEventSelect}
                                        disabled={isSoldOut(availabilitySommerfest2)}
                                    />
                                    <label 
                                        className="form-check-label" 
                                        htmlFor="sommerfest2"
                                        style={{ 
                                            opacity: isSoldOut(availabilitySommerfest2) ? 0.5 : 1,
                                            cursor: isSoldOut(availabilitySommerfest2) ? 'not-allowed' : 'pointer'
                                        }}
                                    >
                                        {resources?.HomeSommerfest2Label}
                                        {isSoldOut(availabilitySommerfest2) && (
                                            <span className="text-danger ms-2">(Ausverkauft)</span>
                                        )}
                                    </label>
                                </div>
                            </div>

                            <div className="mb-4">
                                <p>{resources?.HomeEventNote}</p>
                            </div>

                            <div className="row mt-5">
                                <div className="col-12 text-end">
                                    <button
                                        className="btn-register button"
                                        onClick={onSubmit}
                                        disabled={!selectedTicketTypeId}
                                    >
                                        Weiter
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer language="de" />
                </>
            )}
        </div>
    )
}

export default Home